import LogoArea from "../components/LogoArea";
import {connect} from "react-redux";

function mapStateToProps(state){
    return {
        navigateStatus:state.systemReducer.navigateStatus
    }
}

export default connect(mapStateToProps)(LogoArea)